import * as React from 'react'
import DataTable, { TableColumn } from 'react-data-table-component'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { fechaIsoToYYYY_MM_DD, formatDate } from '../utils/utils'
import { useAuth } from '../hooks/useAuth'
import { AppPath } from '../enums/AppPath'
import Branch from '../interfaces/Branch'
import { BranchState, UserState } from '../enums/DocStates'
import useFilteredData from '../hooks/useFilteredData'
import useBranchesFetcher from '../hooks/useBranchesFetcher'

import CardOneSearch from './CardOneSearch'
import { ButtonMenuSet } from './Buttons'

const dateSort = (rowA: Branch, rowB: Branch) => {
  const today = new Date()
  const a = rowA.createdAt ?? today
  const b = rowB.createdAt ?? today

  if (a > b) {
    return 1
  }

  if (b > a) {
    return -1
  }

  return 0
}

const columns: TableColumn<Branch>[] = [
  {
    name: 'Nombre',
    selector: (row) => row.name,
    sortable: true,
    wrap: true,
    grow: 1,
  },
  {
    name: 'Email',
    selector: (row) => row.email,
    sortable: true,
    grow: 1,
  },
  {
    name: 'Creada',
    selector: (row) => formatDate(fechaIsoToYYYY_MM_DD(row.createdAt)),
    sortable: true,
    sortFunction: dateSort,
    grow: 1,
  },
  {
    name: 'WhatsApp',
    sortable: true,
    cell: (row) => row.whatsapp,
    grow: 1,
  },
]

const buttonCaptions = ['Activas', 'Inactivas']

const Branches: React.FC = () => {
  const [clickedIndex, setClickedIndex] = useState<number>(UserState.Activo)
  const [array, setArray] = useState<Branch[]>([])
  const { userData } = useAuth()
  const [searchTerm, setSearchTerm] = useState('')
  const { fetchBranches, errorBranches } = useBranchesFetcher()

  useEffect(() => {
    if (!userData) return
    fetchAsync(userData?.organization?._id ?? '', clickedIndex)
  }, [clickedIndex])

  const fetchAsync = async (orgId: string, status: BranchState) => {
    const branches = await fetchBranches(orgId, status)

    if (!branches) return
    setArray(branches)
  }

  const navigate = useNavigate()

  const onRowClickedHandler = (row: Branch): void => {
    const url = `/${AppPath.Branches}/view/${row._id}`
    navigate(url)
  }

  // Para la busqueda
  const filtered = useFilteredData({
    array,
    filterFields: [(item) => item.name ?? '', (item) => item.email ?? ''],
    searchTerm,
    allowFilter: true,
  })

  return (
    <div>
      <CardOneSearch
        headerText={'Gestionar '}
        docuType={AppPath.Branches}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        onClearClick={() => {}}
      />
      <div className="mt-2 p-2 mx-auto ">
        <ButtonMenuSet
          captions={buttonCaptions}
          clickedIndex={clickedIndex}
          handleButtonClick={(n) => setClickedIndex(n)}
        />
        <div className="mt-4">
          <DataTable
            columns={columns}
            data={filtered}
            highlightOnHover
            pointerOnHover
            dense
            onRowClicked={onRowClickedHandler}
          />
        </div>
        <div>{errorBranches?.message}</div>
      </div>
    </div>
  )
}
export default Branches
